const testimonials = [
  {
    quote: "Andreas really knows how to bring a techno track to the next level. Sometimes he loses himself in the details, but in the end, that's exactly why the sound, energy, and overall impact hit the way they should in the club.",
    name: "Kaspar",
    role: "Techno Artist",
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/c2d15c9d-fd4c-48dc-b884-daf68069091b_Kaspar.jpg?v=ae681d534a82fcab2131843f9ec7ab47',
  },
  {
    quote: "Ace did a fantastic job on our remix and put a lot of great ideas into the production. His feeling for the original track and the way he developed it helped make the \"You're in the Army Now\" remix such a big success.",
    name: "Captain Jack",
    role: "Eurodance Legend",
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/53e2a153-3ed8-4eb1-bc33-987b5e24c41a_cAPTAIN-jaCK.png?v=8f0ead2315e33d9b1f5191f2f2b373a0',
  },
  {
    quote: "This guy is an absolute machine in the studio. Crazy good ideas, massive sound, and he always knows exactly how to bring out the power of a track to make sure the final result hits hard.",
    name: "Le Shuuk",
    role: "DJ / Producer",
    image: 'https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/27ca7182-572f-49e2-ae6f-fb520e5f0e49_Le-Shuuk.jpg?v=8b16b3a6cf7afe40ba47d1f36d5ab535',
  },
];

export default function Testimonials() {
  return (
    <section
      className="relative py-32 px-6 overflow-hidden"
      style={{
        backgroundImage: `url('https://storage.readdy-site.link/project_files/5bc8e699-d202-4ec0-adea-cc7d9ecf40c0/9e2d3ca5-4b57-4419-b148-77ffbb2dd6b4_ChatGPT-Image-23.-Apr.-2026-22_01_08.png?v=f40b295773c1b01255e1990bf18de570')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70" />
      {/* Top & bottom fade to black */}
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black to-transparent" />
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-px bg-white/30" />
          <span className="text-white/40 text-xs font-medium tracking-[0.3em] uppercase">Testimonials</span>
        </div>
        <h2 className="text-white font-bold leading-tight mb-16" style={{fontSize: 'clamp(2.5rem, 5vw, 4rem)', fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.02em'}}>
          Artists Speak
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <div key={i} className="border border-white/[0.07] rounded-lg p-8 hover:border-white/15 transition-colors duration-300">
              <i className="ri-double-quotes-l text-3xl text-white/15 block mb-6" />
              <p className="text-white/90 text-sm leading-relaxed mb-8 italic" style={{fontFamily: "'Cormorant Garamond', serif", fontSize: '1.05rem'}}>
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-white/40 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
